import HOCbuilder from "../../components/HOCbuilder/HOC";
import Component from "./component";

function OneDriveRedirect() {
  return <HOCbuilder children={<Component />} />;
}

export default OneDriveRedirect;
